const inputStyles = ({ forms, palette, typography }) => ({
  appearance: 'none',
  background: palette.background,
  border: 'none',
  borderBottom: `1px solid`,
  borderColor: ({ error }) => (error ? palette.error : palette.form.placeholder),
  borderRadius: 0,
  color: palette.form.text,
  display: 'block',
  fontFamily: typography.fontFamilies.secondary,
  fontSize: forms.input.fontSize,
  marginTop: 10,
  outline: 'none',
  padding: [10, 0],
  width: '100%',
});

export default inputStyles;
